// By default, this pack is loaded for server-side rendering.
const ReactRailsUJS = require('react_ujs')

// expose react_ujs as `ReactRailsUJS` and prepare a require context
const componentRequireContext = require.context('src/Shared', true)
ReactRailsUJS.useContext(componentRequireContext)
